var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('am-typography',_vm._g({staticClass:"form-back",attrs:{"variant":"body1"}},_vm.$listeners),[_c('a',{attrs:{"href":"#"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }